import { FleekError } from './FleekError';

type Pin = {
  id?: string;
  cid?: string;
  path?: string;
  projectId?: string;
};

type PinNotFoundErrorOptions = {
  pin: Pin;
};

export class PinNotFoundError extends FleekError<PinNotFoundErrorOptions> {
  public name = 'PinNotFoundError';

  toString = () => {
    return 'Pin was not found.';
  };
}
